import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {connect} from "react-redux"
import {createStructuredSelector} from "reselect"
import EventColors from './EventColors';
import Paper from '@material-ui/core/Paper';
import FullCalendar from '@fullcalendar/react'
import EventTooltip from './EventTooltip';
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction";
import timegridPlugin from "@fullcalendar/timegrid";
import {headers} from "constants/csrf"
import esLocale from "@fullcalendar/core/locales/es";
import ptLocale from "@fullcalendar/core/locales/pt";
import Grid from '@material-ui/core/Grid';
import ReactCountryFlag from "react-country-flag";
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import {Box} from '@material-ui/core';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import TechnicianFilter from './TechnicianFilter';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import useCountries from 'hooks/useCountries';
const GET_CALENDAR_EVENTS_REQUEST = "GET_CALENDAR_EVENTS_REQUEST";
const GET_CALENDAR_EVENTS_SUCCESS = "GET_CALENDAR_EVENTS_SUCCESS";
const countries = [
  "MX",
  "CL"
];

const useStyles = makeStyles((theme) => ({

  buttonProgressAbsolute: {
      position: 'absolute',
      left: '50%',
      top: '40%',
  },
  pRelative:{
    position: 'relative',

  }
}));

/*
 npm install --save @fullcalendar/react @fullcalendar/daygrid
 npm install --save @fullcalendar/interaction
 npm install --save @fullcalendar/core
 npm install --save @fullcalendar/timegrid
 npm install --save @fullcalendar/daygrid
 yarn install --check-files
*/
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function getCalendarEvents(country_iso, technician_ids = null, calendar_start_date= null, calendar_finish_date = null, setLoading = null) {
  setLoading && setLoading(true);
  const url = `api/v1/technician_calendar_events?technician_id=${technician_ids}&calendar_start_date=${calendar_start_date.toISOString()}&calendar_finish_date=${calendar_finish_date.toISOString()}&all=1`

  if (technician_ids === null) {
    return dispatch => {
      dispatch(getCalendarEventsSuccess({data: []}))
      setLoading && setLoading(false);
    }
  } else {
    return dispatch => {
      dispatch({type: GET_CALENDAR_EVENTS_REQUEST});
      return fetch(url)
        .then(response => response.json())
        .then(json => {
          dispatch(getCalendarEventsSuccess(json));
          setLoading && setLoading(false);
        })
        .catch(error => {
          console.error('Error fetching calendar events:', error);
          setLoading && setLoading(false);
        });
    };
  }
};

export function getCalendarEventsSuccess(json) {
  return {
    type: GET_CALENDAR_EVENTS_SUCCESS,
    json
  };
};



function Calendar(props) {
  const {i18n,t} = useTranslation();
  const {isos: countryCodes, data: countries, loading: loadingCountries} = useCountries();
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [tecnicos, setTecnicos] = useState([])
  const [selectedTechnicianIds, setSelectedTechnicianIds] = useState([])
  const [start_date, setStartDate] = useState(new Date);
  const [finish_date, setFinishDate] = useState(new Date);
  const [calendar_start_date, setCalendarStartDate] = useState(null);
  const [calendar_finish_date, setCalendarFinishDate] = useState(null);
  const [calendarInitialized, setCalendarInitialized] = useState(false);

  const [allDay, setAllDay] = useState(false);
  const [country, setCountry] = useState("");
  const [eventColors, setEventColors] = useState({})
  const [load, setLoad] = useState(false)
  const calendarRef = React.createRef("")

  async function getEventColors() {
    const {data} = await axios.get('api/v1/calendar_events/colors', {headers: headers})
    setEventColors(data)

  }

  async function getAllTechnicians() {
    const {data} = await axios.get('api/v1/all_technicians', {headers: headers})
    setTecnicos(data)
  }

  // Initialize country from current_user on component mount
  useEffect(() => {
    let user_country = country
    if (props.current_user) {
      if (props.current_user.country != "" && props.current_user.country != null) {
        user_country = props.current_user.country
        setCountry(user_country)
      }
    }
  }, []);

  // Fetch technicians when country changes
  useEffect(() => {
    if (country && country !== "") {
      getAllTechnicians();
    }
  }, [country]);

  // SERVER-SIDE APPROACH: Initial data load when calendar is first rendered
  // This effect runs once on mount to load initial calendar data
  useEffect(() => {
    if (country && calendar_start_date && calendar_finish_date) {
      // For technicians, auto-load their events
      if (props.current_user?.technician || props.current_user?.get_roles_list?.includes('Técnico')) {
        const technicianId = props.current_user.technician_id || props.current_user.id;
        if (!calendarInitialized) {
          setSelectedTechnicianIds([technicianId]);
          // Initial server-side data load for technician
          props.getCalendarEvents(country, technicianId, calendar_start_date, calendar_finish_date, setLoading);
          setCalendarInitialized(true);
        }
      } else {
        // For admins/non-technicians, just mark as initialized so they can select technicians
        if (!calendarInitialized) {
          setCalendarInitialized(true);
        }
      }
    }
  }, [country, calendar_start_date, calendar_finish_date]);

  // CLIENT-SIDE APPROACH: Fetch calendar events when user interacts with filters
  // This effect runs when user changes technician selection or navigates the calendar
  useEffect(() => {
    // Skip if this is the initial load (handled by the effect above)
    if (!calendarInitialized) return;

    // Only fetch if we have valid dates and country
    if (calendar_start_date && calendar_finish_date && country) {
      // For technicians, always use their own ID
      if (props.current_user?.technician || props.current_user?.get_roles_list?.includes('Técnico')) {
        const technicianId = props.current_user.technician_id || props.current_user.id;
        props.getCalendarEvents(country, technicianId, calendar_start_date, calendar_finish_date, setLoading);
      } else if (selectedTechnicianIds.length > 0) {
        // For non-technicians, fetch events for selected technicians
        props.getCalendarEvents(country, selectedTechnicianIds.join(','), calendar_start_date, calendar_finish_date, setLoading);
      }
    }
  }, [calendar_start_date, calendar_finish_date, selectedTechnicianIds]);

  // Handler for technician selection changes from TechnicianFilter
  const handleTechnicianSelectionChange = (technicianIds) => {
    setSelectedTechnicianIds(technicianIds);
  };

  const handleDateClick = (arg) => { // bind with an arrow function
    //alert(arg.dateStr)
  }

  const handleDateSelect = (arg) => { // bind with an arrow function
    setStartDate(arg.start);
    setFinishDate(arg.end);
    setAllDay(arg.allDay)
  }

  const handleDateUnselect = (arg) => { // bind with an arrow function
  }

  const handleCountryChange = (event) => {
    setCountry(event.target.value)
    // props.getCalendarEvents(event.target.value);
  };

  return (
    <React.Fragment>
      <Paper className="custom-paper">

        <Grid container spacing={3}>

          <Grid item xs={12}>
            <h1>{t('calendar.title')}</h1>
            <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} justifyContent="flex-start" gap={2} >
              <div className='country-container' style={{ width: '100%', maxWidth: '300px' }}>
                <FormControl variant="outlined" size="small" fullWidth>
                  <InputLabel className="white-bg padding-sides-5" htmlFor="select-multiple-chip-country" id="country-chip-multiple-label"></InputLabel>
                  {
                    !loadingCountries &&
                    <Select
                    id="country-chip"
                    value={country}
                    onChange={handleCountryChange}
                    input={<OutlinedInput style={{width: '100%'}} />}
                    disabled={loading || props.current_user?.technician || props.current_user?.get_roles_list?.includes('Técnico')} // Disable for technicians
                    renderValue={(selected) => (
                      <div className="">
                        <MenuItem key={selected} value={selected} >
                          <ReactCountryFlag
                            countryCode={selected}
                            svg
                            style={{
                              width: '2em',
                              height: '2em',
                              marginRight: "15px",
                            }}
                            title={selected}
                          />
                          <ListItemText primary={countries.find(object => object["iso"] === selected).name} />
                        </MenuItem>
                      </div>
                    )}
                  >
                    {countryCodes.map((name) => {
                      return props.current_user.countries.find(object => object.iso === name) &&

                        <MenuItem key={name} value={name} >
                          <ReactCountryFlag
                            countryCode={name}
                            svg
                            style={{
                              width: '2em',
                              height: '2em',
                              marginRight: "15px",
                            }}
                            title={name}
                          />
                          <ListItemText primary={countries.find(object => object["iso"] === name).name} />
                        </MenuItem>
                    }
                    )}
                  </Select>

                  }
                </FormControl>
              </div>

              <div className="technician-container" style={{ width: '100%', maxWidth: '300px' }}>
                <TechnicianFilter
                  technicians={tecnicos}
                  setTecnicos={setTecnicos}
                  onTechnicianSelectionChange={handleTechnicianSelectionChange}
                  loading={loading}
                  country={country}
                  currentUser={props.current_user}
                  selectedTechnicianIds={selectedTechnicianIds}
                />
              </div>
            </Box>



            <Box mt={2} >
              <EventColors />
            </Box>

            {/* Custom Navigation Row */}
            <Box mt={2} display="flex" justifyContent="center" alignItems="center" gap={2}>
              <Button
                variant="outlined"
                onClick={() => {
                  const calendarApi = calendarRef.current?.getApi();
                  if (calendarApi) calendarApi.prev();
                }}
                disabled={!country}
              >
                ‹
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  const calendarApi = calendarRef.current?.getApi();
                  if (calendarApi) calendarApi.today();
                }}
                disabled={!country}
              >
                {t('calendar.today') || 'Today'}
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  const calendarApi = calendarRef.current?.getApi();
                  if (calendarApi) calendarApi.next();
                }}
                disabled={!country}
              >
                ›
              </Button>
            </Box>
          </Grid>

          <Grid item xs={12} className={classes.pRelative} >
            {loading && <CircularProgress size={24} className={classes.buttonProgressAbsolute} />}
            {country && (
            <FullCalendar
              timeZone={'local'}
              plugins={[dayGridPlugin, interactionPlugin, timegridPlugin]}
              initialView="timeGridWeek"
              initialDate={new Date()}
              selectable={true}
              ref={calendarRef}
              events={
                props.calendar_events || []
              }
              headerToolbar={{
                start: '',
                center: 'title',
                end: ''
              }}
              footerToolbar={{
                start: '',
                center: 'dayGridMonth,timeGridWeek,timeGridDay',
                end: ''
              }}
              slotLabelFormat={{
                hour: 'numeric',
                minute: '2-digit',
                meridiem: 'short',
                hour12: true
              }}
              datesSet={(dateInfo) => {
                setCalendarStartDate(dateInfo.start)
                setCalendarFinishDate(dateInfo.end)
              }}
              slotLabelContent={(arg) => {
                let label_text = arg.text;
                if (arg.text == "0:00 p. m.") {
                  label_text = "12:00 p. m."
                }
                return (
                  <>
                    {label_text}
                  </>
                );
              }}
              slotDuration={"01:00:00"}
              slotMinTime={"07:00"}
              slotMaxTime={"21:00"}
              locale={i18n.language === 'pt' ?  ptLocale : esLocale}
              dateClick={handleDateClick}
              select={handleDateSelect}
              unselect={handleDateUnselect}
              businessHours={{
                daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
                startTime: '07:00',
                endTime: '21:00',
              }}
              eventContent={(arg) => {
                return (
                  <EventTooltip arg={arg} tecnicos={tecnicos} />
                )
              }}
            />
            )}
          </Grid>
        </Grid>

      </Paper>
    </React.Fragment >
  );

}

const structuredSelector = createStructuredSelector({
  calendar_events: state => state.calendar_events,
  current_user: state => state.current_user
});
const mapDispatchToProps = {getCalendarEvents};

export default connect(structuredSelector, mapDispatchToProps)(Calendar)
